import "./styles.css";

const Button = ({ onClick, buttonText, className }) => (
  <button className={`button ${className}`} onClick={onClick}>{buttonText}</button>
);

export default Button;